const TEAMS = {
  nfl_teams: [
    {
      name: "Buffalo Bills",
      id: "NFL001_BBILLS",
      icon: "Teams/nfl/NFL001_BBILLS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Miami Dolphins",
      id: "NFL002_MDOLPHINS",
      icon: "Teams/nfl/NFL002_MDOLPHINS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "New England Patriots",
      id: "NFL003_NEPATRIOTS",
      icon: "Teams/nfl/NFL003_NEPATRIOTS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "New York Jets",
      id: "NFL004_NYJETS",
      icon: "Teams/nfl/NFL004_NYJETS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Baltimore Ravens",
      id: "NFL005_BRAVENS",
      icon: "Teams/nfl/NFL005_BRAVENS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Cincinnati Bengals",
      id: "NFL006_CBENGALS",
      icon: "Teams/nfl/NFL006_CBENGALS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Cleveland Browns",
      id: "NFL007_CBROWNS",
      icon: "Teams/nfl/NFL007_CBROWNS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Pittsburgh Steelers",
      id: "NFL008_PSTEELERS",
      icon: "Teams/nfl/NFL008_PSTEELERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Houston Texans",
      id: "NFL009_HTEXANS",
      icon: "Teams/nfl/NFL009_HTEXANS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Indianapolis Colts",
      id: "NFL010_ICOLTS",
      icon: "Teams/nfl/NFL010_ICOLTS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Jacksonville Jaguars",
      id: "NFL011_JJAGUARS",
      icon: "Teams/nfl/NFL011_JJAGUARS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Tennessee Titans",
      id: "NFL012_TTITANS",
      icon: "Teams/nfl/NFL012_TTITANS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Denver Broncos",
      id: "NFL013_BBRONCOS",
      icon: "Teams/nfl/NFL013_BBRONCOS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Kansas City Chiefs",
      id: "NFL014_KCCHIEFS",
      icon: "Teams/nfl/NFL014_KCCHIEFS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Las Vegas Raiders",
      id: "NFL015_LVRAIDERS",
      icon: "Teams/nfl/NFL015_LVRAIDERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Los Angeles Chargers",
      id: "NFL016_LACHARGERS",
      icon: "Teams/nfl/NFL016_LACHARGERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Dallas Cowboys",
      id: "NFL017_DCOWBOYS",
      icon: "Teams/nfl/NFL017_DCOWBOYS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "New York Giants",
      id: "NFL018_NYGIANTS",
      icon: "Teams/nfl/NFL018_NYGIANTS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Philadelphia Eagles",
      id: "NFL019_PEAGLES",
      icon: "Teams/nfl/NFL019_PEAGLES.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Washington Commanders",
      id: "NFL020_WCOMMANDERS",
      icon: "Teams/nfl/NFL020_WCOMMANDERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Chicago Bears",
      id: "NFL021_CBEARS",
      icon: "Teams/nfl/NFL021_CBEARS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Detroit Lions",
      id: "NFL022_DLIONS",
      icon: "Teams/nfl/NFL022_DLIONS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Green Bay Packers",
      id: "NFL023_GBPACKERS",
      icon: "Teams/nfl/NFL023_GBPACKERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Minnesota Vikings",
      id: "NFL024_MVIKINGS",
      icon: "Teams/nfl/NFL024_MVIKINGS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Atlants Falcons",
      id: "NFL025_AFALCONS",
      icon: "Teams/nfl/NFL025_AFALCONS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Carolina Panthers",
      id: "NFL026_CPANTHERS",
      icon: "Teams/nfl/NFL026_CPANTHERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "New Orleans Saints",
      id: "NFL027_NOSAINTS",
      icon: "Teams/nfl/NFL027_NOSAINTS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Tampa Bay Buccaneers",
      id: "NFL028_TBBUCCANEERS",
      icon: "Teams/nfl/NFL028_TBBUCCANEERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Arizona Cardinals",
      id: "NFL029_ACARDINALS",
      icon: "Teams/nfl/NFL029_ACARDINALS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Los Angeles Rams",
      id: "NFL030_LARAMS",
      icon: "Teams/nfl/NFL030_LARAMS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "San Francisco 49ers",
      id: "NFL031_SF49ERS",
      icon: "Teams/nfl/NFL031_SF49ERS.png",
      sport: "football",
      league: "nfl",
    },
    {
      name: "Seattle Seahawks",
      id: "NFL032_SSEAHAWKS",
      icon: "Teams/nfl/NFL032_SSEAHAWKS.png",
      sport: "football",
      league: "nfl",
    },
  ],
  epl_teams: [
    {
      name: "Arsenal",
      id: "EPL001_Arsenal",
      icon: "Teams/epl/EPL001_Arsenal.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Aston Villa",
      id: "EPL002_Aston_Villa",
      icon: "Teams/epl/EPL002_Aston_Villa.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Bournemouth",
      id: "EPL003_Bournemouth",
      icon: "Teams/epl/EPL003_Bournemouth.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Brentford",
      id: "EPL004_Brentford",
      icon: "Teams/epl/EPL004_Brentford.png",
      sport: "soccer",
      league: "epl",
    },

    {
      name: "Brighton & Hove Albion",
      id: "EPL005_Brighton_Hove_Albion",
      icon: "Teams/epl/EPL005_Brighton_Hove_Albion.png",
      sport: "soccer",
      league: "epl",
    },

    // {
    //   name: "Burnley F.C.",
    //   id: "EPL022_Burnley",
    //   icon: "Teams/epl/EPL022_Burnley.png",
    //   sport: "soccer",
    //   league: "epl",
    // },

    {
      name: "Chelsea",
      id: "EPL006_Chelsea",
      icon: "Teams/epl/EPL006_Chelsea.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Crystal Palace",
      id: "EPL007_Crystal_Palace",
      icon: "Teams/epl/EPL007_Crystal_Palace.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Everton",
      id: "EPL008_Everton",
      icon: "Teams/epl/EPL008_Everton.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Fulham",
      id: "EPL009_FULHAM",
      icon: "Teams/epl/EPL009_Fulham.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Leeds United",
      id: "EPL010_Leeds_United",
      icon: "Teams/epl/EPL010_Leeds_United.png",
      sport: "soccer",
      league: "epl",
    },
    // {
    //   name: "Leicester City",
    //   id: "EPL011_Leicester_City",
    //   icon: "Teams/epl/EPL011_Leicester_City.png",
    //   sport: "soccer",
    //   league: "epl",
    // },
    {
      name: "Liverpool",
      id: "EPL012_Liverpool",
      icon: "Teams/epl/EPL012_Liverpool.png",
      sport: "soccer",
      league: "epl",
    },
    // {
    //   name: "Luton",
    //   id: "EPL023_Luton",
    //   icon: "Teams/epl/EPL023_Luton.png",
    //   sport: "soccer",
    //   league: "epl",
    // },
    {
      name: "Manchester City",
      id: "EPL013_Manchester_City",
      icon: "Teams/epl/EPL013_Manchester_City.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Manchester United",
      id: "EPL014_Manchester_United",
      icon: "Teams/epl/EPL014_Manchester_United.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Newcastle United",
      id: "EPL015_Newcastle_United",
      icon: "Teams/epl/EPL015_Newcastle_United.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Nottingham Forest",
      id: "EPL016_Nottingham_Forest",
      icon: "Teams/epl/EPL016_Nottingham_Forest.png",
      sport: "soccer",
      league: "epl",
    },
    // {
    //   name: "Sheffield United",
    //   id: "EPL021_Sheffield_United",
    //   icon: "Teams/epl/EPL021_Sheffield_United.png",
    //   sport: "soccer",
    //   league: "epl",
    // },
    // {
    //   name: "Southampton",
    //   id: "EPL017_Southampton",
    //   icon: "Teams/epl/EPL017_Southampton.png",
    //   sport: "soccer",
    //   league: "epl",
    // },
    {
      name: "Spurs",
      id: "EPL018_Spurs",
      icon: "Teams/epl/EPL018_Spurs.png",
      sport: "soccer",
      league: "epl",
    },
    // {
    //   name: "West Ham United",
    //   id: "EPL019_West_Ham_United",
    //   icon: "Teams/epl/EPL019_West_Ham_United.png",
    //   sport: "soccer",
    //   league: "epl",
    // },
    // {
    //   name: "Wolverhampton Wanderers",
    //   id: "EPL020_Wolverhampton_Wanderers",
    //   icon: "Teams/epl/EPL020_Wolverhampton_Wanderers.png",
    //   sport: "soccer",
    //   league: "epl",
    // },
    {
      name: "Ipswich_Town",
      id: "EPL024_Ipswich_Town",
      icon: "Teams/epl/EPL024_Ipswich_Town.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Sunderland",
      id: "EPL025_Sunderland",
      icon: "Teams/epl/EPL025_Sunderland.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Hull City AFC",
      id: "EPL026_Hull_City",
      icon: "Teams/epl/EPL026_Hull_City.png",
      sport: "soccer",
      league: "epl",
    },
    {
      name: "Coventry City Football Club",
      id: "EPL027_Coventry_City",
      icon: "Teams/epl/EPL027_Coventry_City.png",
      sport: "soccer",
      league: "epl",
    },
  ],
  big10_teams: [
    {
      name: "Illinois",
      id: "BIG10001_Illinois",
      icon: "Teams/big10/BIG10001_Illinois.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Indiana",
      id: "BIG10002_Indiana",
      icon: "Teams/big10/BIG10002_Indiana.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Iowa",
      id: "BIG10003_Iowa",
      icon: "Teams/big10/BIG10003_Iowa.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Maryland",
      id: "BIG10004_Maryland",
      icon: "Teams/big10/BIG10004_Maryland.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Michigan State",
      id: "BIG10005_Michigan_State",
      icon: "Teams/big10/BIG10005_Michigan_State.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Michigan",
      id: "BIG10006_Michigan",
      icon: "Teams/big10/BIG10006_Michigan.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Minnesota",
      id: "BIG10007_Minnesota",
      icon: "Teams/big10/BIG10007_Minnesota.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Nebraska",
      id: "BIG10008_Nebraska",
      icon: "Teams/big10/BIG10008_Nebraska.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Northwestern",
      id: "BIG10009_Northwestern",
      icon: "Teams/big10/BIG10009_Northwestern.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Ohio State",
      id: "BIG10010_Ohio_State",
      icon: "Teams/big10/BIG10010_Ohio_State.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Penn State",
      id: "BIG10011_Penn_State",
      icon: "Teams/big10/BIG10011_Penn_State.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Purdue",
      id: "BIG10012_Purdue",
      icon: "Teams/big10/BIG10012_Purdue.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Rutgers",
      id: "BIG10013_Rutgers",
      icon: "Teams/big10/BIG10013_Rutgers.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Wisconsin",
      id: "BIG10014_Wisconsin",
      icon: "Teams/big10/BIG10014_Wisconsin.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Oregon Ducks",
      id: "BIG10015_oregon_ducks",
      icon: "Teams/big10/BIG10015_oregon_ducks.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "UCLA Bruins",
      id: "BIG10016_ucla_bruins",
      icon: "Teams/big10/BIG10016_ucla_bruins.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "USC Trojans",
      id: "BIG10017_usc_trojans",
      icon: "Teams/big10/BIG10017_usc_trojans.png",
      sport: "college",
      league: "big10",
    },
    {
      name: "Washington Huskies",
      id: "BIG10018_washington_huskies",
      icon: "Teams/big10/BIG10018_washington_huskies.png",
      sport: "college",
      league: "big10",
    },
  ],
  nba_teams: [
    {
      name: "Atlanta Hawks",
      id: "NBA001_Hawks",
      icon: "Teams/nba/NBA001_Hawks.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Boston Celtics",
      id: "NBA002_Celtics",
      icon: "Teams/nba/NBA002_Celtics.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Brooklyn Nets",
      id: "NBA003_Nets",
      icon: "Teams/nba/NBA003_Nets.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Charlotte Hornets",
      id: "NBA004_Hornets",
      icon: "Teams/nba/NBA004_Hornets.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Chicago Bulls",
      id: "NBA005_Bulls",
      icon: "Teams/nba/NBA005_Bulls.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Cleveland Cavaliers",
      id: "NBA006_Cavaliers",
      icon: "Teams/nba/NBA006_Cavaliers.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Dallas Mavericks",
      id: "NBA007_Mavericks",
      icon: "Teams/nba/NBA007_Mavericks.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Denver Nuggets",
      id: "NBA008_Nuggets",
      icon: "Teams/nba/NBA008_Nuggets.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Detroit Pistons",
      id: "NBA009_Pistons",
      icon: "Teams/nba/NBA009_Pistons.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Golden State Warriors",
      id: "NBA010_Warriors",
      icon: "Teams/nba/NBA010_Warriors.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Houston Rockets",
      id: "NBA011_Rockets",
      icon: "Teams/nba/NBA011_Rockets.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Indiana Pacers",
      id: "NBA012_Pacers",
      icon: "Teams/nba/NBA012_Pacers.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Los Angeles Clippers",
      id: "NBA013_Clippers",
      icon: "Teams/nba/NBA013_Clippers.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Los Angeles Lakers",
      id: "NBA014_Lakers",
      icon: "Teams/nba/NBA014_Lakers.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Memphis Grizzlies",
      id: "NBA015_Grizzlies",
      icon: "Teams/nba/NBA015_Grizzlies.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Miami Heat",
      id: "NBA016_Heat",
      icon: "Teams/nba/NBA016_Heat.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Milwaukee Bucks",
      id: "NBA017_Bucks",
      icon: "Teams/nba/NBA017_Bucks.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Minnesota Timberwolves",
      id: "NBA018_Timberwolves",
      icon: "Teams/nba/NBA018_Timberwolves.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "New Orleans Pelicans",
      id: "NBA019_Pelicans",
      icon: "Teams/nba/NBA019_Pelicans.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "New York Knicks",
      id: "NBA020_Knicks",
      icon: "Teams/nba/NBA020_Knicks.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Oklahoma City Thunder",
      id: "NBA021_Thunder",
      icon: "Teams/nba/NBA021_Thunder.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Orlando Magic",
      id: "NBA022_Magic",
      icon: "Teams/nba/NBA022_Magic.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Philadelphia 76ers",
      id: "NBA023_76ers",
      icon: "Teams/nba/NBA023_76ers.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Phoenix Suns",
      id: "NBA024_Suns",
      icon: "Teams/nba/NBA024_Suns.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Portland Trail Blazers",
      id: "NBA025_TrailBlazers",
      icon: "Teams/nba/NBA025_TrailBlazers.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Sacramento Kings",
      id: "NBA026_Kings",
      icon: "Teams/nba/NBA026_Kings.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "San Antonio Spurs",
      id: "NBA027_Spurs",
      icon: "Teams/nba/NBA027_Spurs.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Toronto Raptors",
      id: "NBA028_Raptors",
      icon: "Teams/nba/NBA028_Raptors.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Utah Jazz",
      id: "NBA029_Jazz",
      icon: "Teams/nba/NBA029_Jazz.png",
      sport: "basketball",
      league: "nba",
    },
    {
      name: "Washington Wizards",
      id: "NBA030_Wizards",
      icon: "Teams/nba/NBA030_Wizards.png",
      sport: "basketball",
      league: "nba",
    },
  ],
  wnba_teams: [
    {
      name: "Atlanta Dream",
      id: "WNBA001_Dream",
      icon: "Teams/wnba/WNBA001_Dream.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Chicago Sky",
      id: "WNBA002_Sky",
      icon: "Teams/wnba/WNBA002_Sky.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Connecticut Sun",
      id: "WNBA003_Sun",
      icon: "Teams/wnba/WNBA003_Sun.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Dallas Wings",
      id: "WNBA004_Wings",
      icon: "Teams/wnba/WNBA004_Wings.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Golden State Valkyries",
      id: "WNBA005_Valkyries",
      icon: "Teams/wnba/WNBA005_Valkyries.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Indiana Fever",
      id: "WNBA006_Fever",
      icon: "Teams/wnba/WNBA006_Fever.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Las Vegas Aces",
      id: "WNBA007_Aces",
      icon: "Teams/wnba/WNBA007_Aces.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Los Angeles Sparks",
      id: "WNBA008_Sparks",
      icon: "Teams/wnba/WNBA008_Sparks.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Minnesota Lynx",
      id: "WNBA009_Lynx",
      icon: "Teams/wnba/WNBA009_Lynx.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "New York Liberty",
      id: "WNBA010_Liberty",
      icon: "Teams/wnba/WNBA010_Liberty.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Phoenix Mercury",
      id: "WNBA011_Mercury",
      icon: "Teams/wnba/WNBA011_Mercury.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Portland Fire",
      id: "WNBA015_Fire",
      icon: "Teams/wnba/WNBA015_Fire.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Seattle Storm",
      id: "WNBA012_Storm",
      icon: "Teams/wnba/WNBA012_Storm.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Toronto Tempo",
      id: "WNBA013_Tempo",
      icon: "Teams/wnba/WNBA013_Tempo.png",
      sport: "basketball",
      league: "wnba",
    },
    {
      name: "Washington Mystics",
      id: "WNBA014_Mystics",
      icon: "Teams/wnba/WNBA014_Mystics.png",
      sport: "basketball",
      league: "wnba",
    },
  ],
  mlb_teams: [
    {
      name: "Arizona Diamondbacks",
      id: "MLB001_Diamondbacks",
      icon: "Teams/mlb/Diamondbacks.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Atlanta Braves",
      id: "MLB002_Braves",
      icon: "Teams/mlb/Braves.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Baltimore Orioles",
      id: "MLB003_Orioles",
      icon: "Teams/mlb/Orioles.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Boston Red Sox",
      id: "MLB004_RedSox",
      icon: "Teams/mlb/Redsox.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Chicago Cubs",
      id: "MLB005_Cubs",
      icon: "Teams/mlb/Cubs.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Chicago White Sox",
      id: "MLB006_WhiteSox",
      icon: "Teams/mlb/Whitesox.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Cincinnati Reds",
      id: "MLB007_Reds",
      icon: "Teams/mlb/Reds.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Cleveland Guardians",
      id: "MLB008_Guardians",
      icon: "Teams/mlb/Guardians.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Colorado Rockies",
      id: "MLB009_Rockies",
      icon: "Teams/mlb/Rockies.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Detroit Tigers",
      id: "MLB010_Tigers",
      icon: "Teams/mlb/Tigers.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Houston Astros",
      id: "MLB011_Astros",
      icon: "Teams/mlb/Astros.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Kansas City Royals",
      id: "MLB012_Royals",
      icon: "Teams/mlb/Royals.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Los Angeles Angels",
      id: "MLB013_Angels",
      icon: "Teams/mlb/Angels.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Los Angeles Dodgers",
      id: "MLB014_Dodgers",
      icon: "Teams/mlb/Dodgers.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Miami Marlins",
      id: "MLB015_Marlins",
      icon: "Teams/mlb/Marlins.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Milwaukee Brewers",
      id: "MLB016_Brewers",
      icon: "Teams/mlb/Brewers.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Minnesota Twins",
      id: "MLB017_Twins",
      icon: "Teams/mlb/Twins.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "New York Mets",
      id: "MLB018_Mets",
      icon: "Teams/mlb/Mets.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "New York Yankees",
      id: "MLB019_Yankees",
      icon: "Teams/mlb/Yankees.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Athletics",
      id: "MLB020_Athletics",
      icon: "Teams/mlb/Athletics.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Philadelphia Phillies",
      id: "MLB021_Phillies",
      icon: "Teams/mlb/Phillies.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Pittsburgh Pirates",
      id: "MLB022_Pirates",
      icon: "Teams/mlb/Pirates.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "San Diego Padres",
      id: "MLB023_Padres",
      icon: "Teams/mlb/Padres.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "San Francisco Giants",
      id: "MLB024_Giants",
      icon: "Teams/mlb/Giants.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Seattle Mariners",
      id: "MLB025_Mariners",
      icon: "Teams/mlb/Mariners.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "St. Louis Cardinals",
      id: "MLB026_Cardinals",
      icon: "Teams/mlb/Cardinals.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Tampa Bay Rays",
      id: "MLB027_Rays",
      icon: "Teams/mlb/Rays.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Texas Rangers",
      id: "MLB028_Rangers",
      icon: "Teams/mlb/Rangers.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Toronto Blue Jays",
      id: "MLB029_BlueJays",
      icon: "Teams/mlb/BlueJays.png",
      sport: "baseball",
      league: "mlb",
    },
    {
      name: "Washington Nationals",
      id: "MLB030_Nationals",
      icon: "Teams/mlb/Nationals.png",
      sport: "baseball",
      league: "mlb",
    },
  ],
};

export default TEAMS;
